var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5C13.8807 15.5 15 14.3807 15 13C15 11.6193 13.8807 10.5 12.5 10.5C11.1193 10.5 10 11.6193 10 13C10 14.3807 11.1193 15.5 12.5 15.5Z",
    stroke: "#929292",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 20.5001C4.16699 13.0362 4.16699 9.30423 6.48573 6.98548C8.80448 4.66675 12.5364 4.66675 20.0003 4.66675C27.4642 4.66675 31.1962 4.66675 33.515 6.98548C35.8337 9.30423 35.8337 13.0362 35.8337 20.5001C35.8337 27.9639 35.8337 31.6959 33.515 34.0147C31.1962 36.3334 27.4642 36.3334 20.0003 36.3334C12.5364 36.3334 8.80448 36.3334 6.48573 34.0147C4.16699 31.6959 4.16699 27.9639 4.16699 20.5001Z",
    stroke: "#929292",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 35.4999C15.6204 26.7916 23.7898 15.3067 35.8288 23.0706",
    stroke: "#929292",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.6a59fcd4d7f1b724644af918a2bd1925.svg";
export { ForwardRef as ReactComponent };